
import React, {FC} from 'react';
import {Modal, Spinner} from 'react-bootstrap';
import ApptDetails from 'components/ApptDetails2';
import Button from 'components/Button';
import {FullPageSpinner} from 'components/FullPageSpinner';
import {ReloadError} from 'components/ReloadError';
import {TimeSlot} from 'components/TimePicker/types';

import {Form} from './Form';
import {useState} from './reducer';

import * as styles from './styles.module.scss';

type ConfirmProps = {
	partner: string
	time: TimeSlot
	onHide: () => void
}

export const Confirm: FC<ConfirmProps> = ({partner, time, onHide}) => {
	const {state, creating, onClick} = useState({
		partner,
		appt: time.id,
	});

	const Content = () => {
		if (state.step === 'LOADING' || !state.appt || !state.auth) {
			return <FullPageSpinner />;
		} else if (state.step === 'ERROR') {
			return <ReloadError>{state.error}</ReloadError>;
		}

		// Dynamically create some shared components
		const shared: Record<string, React.ReactNode> = {
			details: (
				<ApptDetails
					className={styles.appt}
					countdown={false}
					details={state.appt}
				/>
			),
			spinner: creating && <Spinner size='sm' />,
		};

		// Create new user & reserve all at once
		if (state.step === 'CREATE') {
			return (
				<>
					{shared.details}
					<Form loading={creating} onSubmit={onClick}>
						Confirm appointment {shared.spinner}
					</Form>
				</>
			);
		}

		// Already logged in, confirm partner reservation
		if (state.step === 'CONFIRM') {
			const user = state.auth.user?.name;
			return (
				<>
					{shared.details}
					<div className={styles.message}>
						<span>Logged in as {user}:</span>
						<Button
							disabled={creating}
							variant='primary'
							onClick={onClick}
						>
							Confirm appointment {shared.spinner}
						</Button>
					</div>
				</>
			);
		}

		if (state.step === 'LOG-IN') {
			return (
				<>
					{shared.details}
					<div className={styles.message}>
						<span>
							This email is already linked to a BodySpec account.
							Please sign in to continue:
						</span>
						<Button variant='primary' onClick={onClick}>
							Sign in
						</Button>
					</div>
				</>
			);
		}

		return null;
	};

	return (
		<Modal show scrollable onHide={onHide}>
			<Modal.Header closeButton>
				Confirm your appointment
			</Modal.Header>
			<Modal.Body className={styles.confirm}>
				<Content />
			</Modal.Body>
		</Modal>
	);
};
